import { render, staticRenderFns } from "./UploadLogoModal.vue?vue&type=template&id=4164720e"
import script from "./UploadLogoModal.vue?vue&type=script&lang=js"
export * from "./UploadLogoModal.vue?vue&type=script&lang=js"
import style0 from "./UploadLogoModal.vue?vue&type=style&index=0&id=4164720e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports